let snackbarRef: any = null;

export const setSnackbarRef = (ref: any) => {
    snackbarRef = ref;
};

export const enqueueSnackbar = (message: any, options: any) => {
    if (snackbarRef) {
        snackbarRef.enqueueSnackbar(message, options);
    }
};

export const dequeueSnackbar = () => {
    // Implement dequeueing logic if necessary
};